import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _get from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _wrapNativeSuper from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var a = /*#__PURE__*/function (_Map) {
  function a(t) {
    var _this;
    _classCallCheck(this, a);
    _this = _callSuper(this, a);
    _this.factory = t;
    return _this;
  }
  _inherits(a, _Map);
  return _createClass(a, [{
    key: "get",
    value: function get(t) {
      var e = _get(_getPrototypeOf(a.prototype), "get", this).call(this, t);
      return e === void 0 && (e = this.factory(t), this.set(t, e)), e;
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(Map));
export { a as DefaultMap };